import React from 'react';

import { SupplierStatusTypes } from '@common/graphql';
import { Colors } from '@common/tokens';

type Props = {
  status?: SupplierStatusTypes;
};

const statusColorMap = {
  ACTIVE: { color: Colors.grassMid, label: 'Active' },
  AVAILABLE: { color: Colors.hypnotiqRegular, label: 'Available' },
  INVITED: { color: Colors.sunDarkest, label: 'Invited' },
  DECLINED: { color: Colors.coral, label: 'Declined' },
  PENDING_ACTIVATION: { color: Colors.sunDarkest, label: 'Pending Activation' },
  PENDING_SIGNUP: { color: Colors.sunDarkest, label: 'Pending Signup' },
};

export function SupplierStatus({ status }: Props) {
  if (!status) {
    return null;
  }

  const { color, label } = statusColorMap[status] || {};
  return (
    <span style={{ color }} className="text-heavy">
      {label}
    </span>
  );
}
